//WE.Flow.Html.Contracts.Manifests.LicenseBundle

export class LicenseBundle {
    path: string = "";
}
